export interface DetectLanguageRequest {
    /** 用户输入的权利要求文本 */
    claim: string;
    /** 用户输入的交底书文本 */
    disclosure: string;
    /** 受理局 USPTO/CNIPA/EPO */
    jurisdiction: string;
}

export interface DetectLanguageResponse {
    /** failed - 根据operation弹框  success- 直接进入下一步 */
    result: 'failed' | 'success';
    /** modify：修改弹框  suggest：推荐弹框  unsupported：不支持弹框 */
    operation?: 'modify' | 'suggest' | 'unsupported';
    /** 推荐弹框推荐值 */
    suggestion?: string;
}

export const DetectLanguageApi = Symbol.for('DetectLanguageApi');

export interface DetectLanguageApi {
    detectLanguage(data: DetectLanguageRequest): Promise<DetectLanguageResponse>;
}
